@if(staff) {
<div class="card shadow-sm rounded border-0 m-3">
  <div class="card-header text-center bg-body">
    <div class="d-flex flex-column align-items-center gap-1">
      <div class="rounded-circle overflow-hidden img-container">
        @if(staff.user.awsBucketAvatarKey) {
        <img
          class="h-100 w-auto"
          [src]="staff.user.awsBucketAvatarKey | signedUrl : awsPath | async"
          alt="Patient avatar"
        />}@else{
        <i class="bi bi-person-circle text-secondary"></i>
        }
      </div>
      <span class="badge bg-dark ms-2"> {{ staff.position.name }} </span>
      <div class="d-flex gap-2">
        <h5>{{ staff.user | fullName }} ({{ staff.id }})</h5>
        <app-copy [content]="(staff.user | fullName) + ' ' + '(' + staff.id + ')'"></app-copy>
      </div>
      <div class="d-flex gap-2">
        <h6>{{ staff.clinic.longName }} ({{ staff.clinic.id }})</h6>
        <app-copy [content]="staff.clinic.longName + ' ' + '(' + staff.clinic.id + ')'"></app-copy>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="mb-2 d-flex align-items-center">
      <strong class="me-1">{{ 'gender' | transloco }}:</strong>
      <span class="me-2">{{ staff.user.gender | transloco }}</span>

      <i
        class="bi bi-gender-{{ staff.user.gender }}"
        [ngStyle]="{
          color: staff.user.gender === 'male' ? '#3399cc' : 'hotpink'
        }"
      ></i>
    </div>
    <div class="mb-2">
      <strong>{{ 'status' | transloco }}:</strong>
      <span class="badge bg-{{ staff.user.status }} ms-2">
        {{ staff.user.status | transloco }}
      </span>
    </div>
    <div class="mb-2">
      <strong>{{ 'phone' | transloco }}:</strong>
      <span class="ms-2">{{ staff.user.phones[0].number }}</span>
    </div>
    <div class="mb-2">
      <strong>{{ 'email' | transloco }}:</strong>
      <span class="ms-2">{{ staff.user.email }}</span>
    </div>
    <div class="mb-2">
      <strong>{{ 'birthday' | transloco }}:</strong>
      <span class="ms-2">{{ staff.user.birthDate | date : 'dd/MM/YYYY' }}</span>
    </div>
    <app-solvaig-instruction></app-solvaig-instruction>
  </div>
</div>

}
